<template>
  <div
    class="d-flex justify-content-between align-items-center"
    style="
      border-radius: 8px;
      background-color: var(--blue-light);
      border: 1px solid var(--blue-medium);
    "
  >
    <img
      :src="require('@/assets/images/svg/ícone-loja.svg')"
      alt=""
      style="margin: 13px"
    />
    <span style="width: 187px">
      <p
        style="
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          color: var(--grey-medium);
          margin: 0;
        "
      >
        Loja selecionada
      </p>
      <p
        style="
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          color: var(--black-medium);
          margin: 0;
        "
      >
        {{ selectedStore }}
        {{ selectedStoreQuantity > 1 ? `+ ${selectedStoreQuantity - 1}` : "" }}
      </p>
    </span>
    <img
      :src="require('@/assets/images/svg/ícone-seta-direita-azul.svg')"
      alt=""
      data-bs-toggle="modal"
      data-bs-target="#modalSelectedStore"
    />
    <!-- Modal -->
    <div
      class="modal fade"
      data-bs-backdrop="false"
      id="modalSelectedStore"
      tabindex="1"
      aria-labelledby="modalSelectedStoreLabel"
      aria-hidden="true"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form ref="filters">
            <div class="modal-header border-0 pb-0">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div class="modal-body mt-0 pt-0 pb-0">
              <h5
                class="modal-title"
                id="modalSelectedStoreLabel"
                style="
                  font-style: normal;
                  font-weight: 700;
                  font-size: 24px;
                  color: var(--grey-medium);
                "
              >
                Escolha a conta da loja para visualização
              </h5>
              <p
                style="
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  color: var(--black-medium);
                "
              >
                Nós iremos mostrar as publicação e métricas da conta do
                instagram da loja selecionada nesta etapa
              </p>
              <InputSearch @onUpdate="(value) => getStoreByName(value)" />
              <section
                class="d-flex justify-content-center align-items-center w-100 flex-column row-gap-3"
                style="margin-top: 24px"
              >
                <Accordion
                  :title="'Regionais'"
                  v-if="nameToSearch.length === 0"
                >
                  <SubAccordion
                    :title="Rstore[0].regionalName"
                    :id="`${Rstore.id}`"
                    v-for="Rstore in Rstores"
                    :key="Rstore.id"
                    @selectAll="(regional) => selectAllRegional(regional)"
                  >
                    <AccordionItem
                      v-for="store in Rstore"
                      :key="store.id"
                      :item="store"
                      :selected="storeIsChecked(store.instaPageId)"
                      @filter="
                        (checked) =>
                          filter(checked, store.instaPageId, store.pageName)
                      "
                    />
                  </SubAccordion>
                </Accordion>

                <Accordion
                  :title="'Lojas'"
                  :stores="true"
                  @selectAll="selectAll(stores)"
                >
                  <AccordionItem
                    v-for="store in stores"
                    :key="store.id"
                    :item="store"
                    :selected="storeIsChecked(store.instaPageId)"
                    @filter="
                      (checked) =>
                        filter(checked, store.instaPageId, store.pageName)
                    "
                  />
                </Accordion>
              </section>
            </div>

            <div class="d-flex w-100 justify-content-center align-items-center">
              <button
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
                style="
                  border-radius: 8px;
                  text-align: center;
                  background-color: var(--blue-light);
                  color: var(--blue-medium);
                  font-style: normal;
                  font-weight: 500;
                  font-size: 16px;
                  height: 56px;
                  margin: 8px;
                "
                class="border-0 w-100"
              >
                Voltar
              </button>
              <button
                type="button"
                class="border-0 w-100"
                :class="disabled ? 'disabled' : 'activated'"
                :disabled="disabled"
                data-bs-dismiss="modal"
                aria-label="Close"
                @click="handleSelectedStores"
              >
                Salvar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- Vertically centered modal -->
</template>
<script>
import InputSearch from "@/components/InputSearch.vue";
import Accordion from "./ui/accordion/accordion.vue";
import AccordionItem from "./ui/accordion/accordionItem.vue";
import SubAccordion from "./ui/accordion/subAccordion.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "Stores",
  components: { InputSearch, Accordion, AccordionItem, SubAccordion },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedStore: "Selecionar loja",
      stores: [],
      filtros: {},
      disabled: true,
      totalStores: 0,
      offset: 0,
      nameToSearch: "",
      selectedStoreQuantity: 0,
      Rstores: {},
      preSelect: [],
    };
  },
  created() {
    this.getStoresByPagination({
      action: "clickFirstPage",
      offset: 0,
      name: this.nameToSearch,
      limit: 5,
    })
      .then((response) => {
        this.totalStores = response.data.count;
        this.stores = response.data.data;

        response.data.groupedRegional.map((store) => {
          if (store.regional in this.Rstores) {
            // ok
          } else {
            this.Rstores[store.regional] = store.lojas;
          }
        });

        if (response.data.data.length > 0) {
          this.selectedStore = response.data.data[0].pageName;
          this.SET_STORES([response.data.data[0].instaPageId]);
          this.preSelect = [response.data.data[0].instaPageId];
        }
      })
      .catch((err) => console.error(err));
  },
  computed: {
    ...mapGetters(["getSelectedStores", "getOffset"]),
  },
  methods: {
    ...mapActions(["getStoresByPagination", "getStoresByRegional"]),
    ...mapMutations(["SET_STORES", "SET_OFFSET"]),

    getStoreByName: function getStoreByName(name) {
      this.nameToSearch = name;

      if (this.nameToSearch != "") {
        let objThis = this;

        clearTimeout(getStoreByName);

        setTimeout(function () {
          objThis.pagination("clickFirstPage");
        }, 500);
      } else {
        this.pagination("clickFirstPage");
      }
    },
    filter(checked, id, name) {
      let intArr = this.preSelect;

      if (this.preSelect.length > 0) {
        if (this.preSelect.includes(id)) {
          intArr.splice(intArr.indexOf(id), 1);
          this.preSelect = intArr;
        } else {
          intArr.push(id);
          this.preSelect = intArr;
        }
      } else {
        this.preSelect = [id];
      }
    },
    selectAll(items) {
      const storesIds = items.map((store) => store.instaPageId);

      if (this.preSelect.length === 0) {
        this.preSelect = storesIds;
      } else if (
        this.preSelect.length !== storesIds.length &&
        this.preSelect.length > 0
      ) {
        this.preSelect = [];

        this.preSelect = storesIds;
      } else {
        this.preSelect = [];
      }
    },
    pagination(action) {
      const data = {
        action: action,
        offset: 0,
        name: this.nameToSearch,
        limit: 5,
      };
      switch (action) {
        case "clickFirstPage":
          this.offset = 0;
          this.SET_OFFSET(0);
          this.getStoresByPagination(data).then((response) => {
            this.totalStores = response.data.count;
            this.stores = response.data.data;
          });
          break;
        case "clickPreviousPage": {
          this.SET_OFFSET(this.getOffset - data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getStoresByPagination(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        case "clickNextPage": {
          this.SET_OFFSET(this.getOffset + data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getStoresByPagination(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        case "clickLastPage": {
          let lastPage;
          if (this.totalStores % data.limit === 0) {
            lastPage = this.totalStores - data.limit;
          } else {
            lastPage = Math.floor(this.totalStores / data.limit) * data.limit;
          }

          this.SET_OFFSET(lastPage);

          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getStoresByPagination(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        default:
          break;
      }
    },
    storeIsChecked(id) {
      if (this.preSelect.includes(id)) {
        return true;
      } else {
        return false;
      }
    },
    selectAllRegional(regionalName) {
      let intArr = this.preSelect;
      const regional = this.Rstores[regionalName].map(
        (store) => store.instaPageId
      );

      const has = regional.every((id) => intArr.includes(id));

      if (has) {
        regional.map((id) => {
          const index = intArr.indexOf(id);

          if (index !== -1) {
            intArr.splice(index, 1);

            this.preSelect = intArr;
          }
        });
      } else {
        const newArr = intArr.concat(regional);

        this.preSelect = newArr;
      }
    },
    handleSelectedStores() {
      this.SET_STORES(this.preSelect);
    },
  },
  watch: {
    async getSelectedStores(newValue) {
      this.selectedStoreQuantity = newValue.length;

      if (newValue.length > 0) {
        try {
          await this.getStoresByPagination({
            action: "clickFirstPage",
            offset: 0,
            name: this.nameToSearch,
            limit: 1,
            id: newValue,
          })
            .then((response) => {
              if (response.data.data.length > 0) {
                this.selectedStore = response.data.data.find(
                  (data) => data.instaPageId === newValue[0]
                )?.pageName;
              } else {
                this.selectedStore = "Selecionar loja";
              }
            })
            .catch((err) => console.error(err));
        } catch (error) {
          console.error(error);
        }
      } else {
        this.selectedStore = "Selecionar loja";
      }
      this.disabled = false;
    },
  },
};
</script>
<style scoped>
.activated,
.disabled {
  border-radius: 8px;
  text-align: center;
  color: var(--white);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  height: 56px;
  margin: 8px;
}

.activated {
  background-color: var(--green-medium);
}
.disabled {
  background-color: var(--grey-border);
}
</style>
